import { SaleDetail, SaleFormValues } from '../../../types/sale';

export const mapExportInvoice = (data: SaleDetail): SaleFormValues => ({
  id: data.id,
  correlativeId: data?.correlativeId,
  documentNumber: data.documentNumber,
  saleDate: data.saleDate,
  branch: data.branch,
  customer: data.customer,
  documentType: data.documentType,
  paymentMethod: data.paymentMethod,
  globalDiscountPercentage: data.globalDiscountPercentage || 0,
  globalDiscountTarget: data.globalDiscountTarget || 'PRODUCTS',
  paymentCondition: data.paymentCondition,
  comments: data.comments,
  products: data.exportInvoiceDetails?.products || [],
  totals: data.exportInvoiceDetails?.totals || {},
  totalsView: data.exportInvoiceDetails?.totalsView || {},
});
